import { Icon, type IconName } from '@components/atoms/Icon'
import { useTheme } from '@context/ThemeContext'
import type { ThemePreference } from '@context/ThemeContext'
import styles from './ThemeSwitcher.module.scss'

interface Segment {
  value: ThemePreference
  label: string
  icon: IconName
}

const segments: Segment[] = [
  { value: 'light', label: 'Light', icon: 'sun' },
  { value: 'system', label: 'System', icon: 'monitor' },
  { value: 'dark', label: 'Dark', icon: 'moon' },
]

export function ThemeSwitcher() {
  const { theme, setTheme } = useTheme()

  return (
    <div
      className={styles.root}
      role="radiogroup"
      aria-label="Theme preference"
    >
      {segments.map(({ value, label, icon }) => {
        const isActive = theme === value
        return (
          <button
            key={value}
            type="button"
            role="radio"
            aria-checked={isActive}
            aria-pressed={isActive}
            className={`${styles.segment} ${isActive ? styles.segmentActive : ''}`}
            onClick={() => setTheme(value)}
          >
            <Icon name={icon} size={14} color="currentColor" />
            <span className={styles.label}>{label}</span>
          </button>
        )
      })}
    </div>
  )
}
